import fileType from 'file-type/browser'

export default {
    async getExtByFileOrUrl(blob, url) {
        let ext = this.getExtByUrl(url)
        if (ext) return ext
        return this.getExtByFile(blob)
    },
    getExtByUrl(url) {
        let file = new URL(url).pathname
        if (file.split('.').length >= 2) {
            return file.split('.').pop()
        }
    },
    async getExtByFile(blob) {
        let res = await fileType.fromBlob(blob)
        let { ext } = res
        return ext
    },
    downloadBlob(filename, blob) {
        let a = document.createElement('a')
        a.download = filename
        a.target = "_blank"
        a.href = URL.createObjectURL(blob)
        a.click()
    }
}